import { Note } from "../searchesNotOrdered/types";

export function processNoteUserAndText(note: Note) {
  const noteTextParts = note.text?.split("added this note: ");
  const createdByUser = noteTextParts?.length > 1 ? noteTextParts[0] : note.fullName;
  const text = noteTextParts?.length > 1 ? noteTextParts[1] : noteTextParts[0];
  return {
    createdByUser,
    text
  };
}

export const processedNotes = (notes: Note[]) => {
  return notes.map((n) => ({ ...n, ...processNoteUserAndText(n) }));
};
